import React, {Component, Fragment} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core/styles";
import favicon from '../images/frankkienl-310.png';

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  logo: {
    maxHeight: '40px',
  }
};


class TopBar extends Component {

  componentDidMount() {
    //add listeners
  }

  render() {
    const {classes} = this.props;

    return (
      <div className='flexGrow'>
        <AppBar position="static">
          <Toolbar>
            <Fragment>
              <a href="/">
                <img src={favicon} alt="logo" className={classes.logo}/>
              </a>
              <Typography variant="h6" color="inherit" className={classes.grow}>
                Frankkie.NL
              </Typography>
            </Fragment>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export default withStyles(styles)(TopBar);
